<template>
   <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>loading</h5>
        <br>
      <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>

      <b-container fluid v-if="this.inSession">
        <div class="e-box" style="height:100%;padding:0 !important;margin-left:0 !important;margin-right:0 !important">
          <b-row>
            <b-col cols="2" class="text-left" style="padding-right:0">
              <b-img v-if="leftVisible"
                class="w-cursor-click"
                width=30px
                height=30px
                :src="require('@/assets/img/left.png')"
                @click="onLeft"
              >
              </b-img>
            </b-col>                
            <b-col cols="8" class="text-center" style="padding-left:0;padding-right:0;">
              <p v-if="this.pageCount == 0" 
                class="current-page w-cursor-default"
              >
                <b>{{ translate("wine") }}</b> -
              </p>
              <p v-else 
                class="w-page w-cursor-click"
                @click="onWine"
              >
                {{ translate("wine") }} -
              </p>

              <p v-if="this.pageCount == 1" 
                class="current-page w-cursor-default"
              >
                <b>{{ translate("purchase") }}</b> -
              </p>
              <p v-else 
                class="w-page w-cursor-click"
                @click="onPurchase"
              >
                {{ translate("purchase") }} -
              </p>              

              <p v-if="this.pageCount == 2" 
                class="current-page w-cursor-default"
              >
                <b>{{ translate("detail") }}</b> -
              </p>
              <p v-else 
                class="w-page w-cursor-click"
                @click="onDetail"
              >
                {{ translate("detail") }} -
              </p>

              <p v-if="this.pageCount == 3" 
                class="current-page w-cursor-click"
              >
                <b>{{ translate("pictures") }}</b>
              </p>
              <p v-else 
                class="w-page w-cursor-click"
                @click="onPictures"
              >
                {{ translate("pictures") }}
              </p>
              <p class="w-smalltext" style="text-align:center">{{ translate("page") }} {{this.pageCount+1}}/{{this.maxPage+1}}</p>
            </b-col>
            <b-col cols="2" class="text-right" style="padding-left:0">
              <b-img v-if="rightVisible"
                class="w-cursor-click"
                width=30px
                height=30px
                :src="require('@/assets/img/right.png')"
                @click="onRight"
              >
              </b-img>
            </b-col>
            <br>                
          </b-row> 
          <b-form autocomplete="off">
            <div v-if="pageCount == 0" class="page">
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <b-row>
                      <b-col>  
                        <label class="w-label w-required" for="input-name">{{ translate("winery name") }}</label>
                      </b-col>
                      <b-col class="text-right">
                        <label class="w-error" v-if="!this.nameValid">{{nameFeedback}}</label>
                      </b-col>
                    </b-row>
                    <b-form-input
                      id="input-name"
                      class="w-input"
                      v-model="entry.name"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.nameValid}"
                      aria-describedby="input-live-help input-live-feedback"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <label class="w-label" for="input-type">{{ translate("wine name") }}</label>
                    <b-form-input
                      id="input-type"
                      class="w-input"
                      v-model="entry.type"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.typeValid}"
                      aria-describedby="input-live-help input-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-live-feedback">
                    {{typeFeedback}}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <b-row>
                      <b-col>  
                        <label class="w-label w-required" for="vintageList">{{ translate("vintage") }}</label>
                      </b-col>
                      <b-col class="text-right">
                        <label class="w-error" v-if="!this.vintageValid">{{vintageFeedback}}</label>
                      </b-col>
                    </b-row>   
                    <model-select 
                      id="vintageList"
                      class="w-select"
                      :options="vintages"
                      v-model="entry.vintage"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.vintageValid}"
                      @input="inputVintage"
                    >
                    </model-select>             
                  </b-form-group>
                </b-col>
              </b-row>
              <div v-if="!freeFormat">
                <b-row>
                  <b-col>
                    <b-form-group style="text-align:left">
                      <b-row>
                        <b-col>  
                          <label class="w-label w-required" for="countryList">{{ translate("country") }}</label>
                        </b-col>
                        <b-col class="text-right">
                          <label class="w-error" v-if="!this.countryValid">{{countryFeedback}}</label>
                        </b-col>
                      </b-row>      
                      <model-select
                        id="countryList"
                        class="w-select"
                        :options="countries"
                        v-model="entry.country_id"
                        v-bind:class="{'form-control':true, 'is-invalid' : !this.countryValid}"
                        @input="inputCountry"
                      >
                      </model-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group style="text-align:left">
                      <label class="w-label" for="regionList">{{ translate("region") }}</label>        
                      <model-select
                        class="w-select"
                        :options="regions"
                        :isDisabled= !region_isActive
                        v-model="entry.region_id"
                        @input="inputRegion"
                      >
                      </model-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group style="text-align:left">
                      <label class="w-label" for="appellationList" v-if="entry.country=='Italia'">denominazione</label>
                      <label class="w-label" for="appellationList" v-else-if="entry.country=='Espagna'">denominación</label>
                      <label class="w-label" for="appellationList" v-else-if="entry.country=='Deutschland'">einzellage	- großlage</label>
                      <label class="w-label" for="appellationList" v-else-if="entry.country=='USA'">AVA</label>
                      <label class="w-label" for="appellationList" v-else-if="entry.country=='Australia'">Geographical Indication</label>
                      <label class="w-label" for="appellationList" v-else>appellation</label>  
                      <model-select
                        class="w-select"
                        :options="appellations"
                        :isDisabled = !appellation_isActive
                        v-model="entry.appellation_id"
                        @input="inputAppellation"
                      >
                      </model-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group style="text-align:left">
                      <label class="w-label" for="classificationList">{{ translate("classification") }}</label>        
                      <model-select
                        class="w-select"
                        :options="classifications"
                        :isDisabled = !classification_isActive
                        v-model="entry.classification_id"
                        @input="inputClassification"
                      >
                      </model-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <b-row>
                  <b-col style="position:relative">
                    <b-form-group style="text-align:left">
                      <label class="w-label" for="input-country" style="font-weight:bold; color:rgb(109,122,82) !important">{{ translate("country - free format") }}</label>
                      <b-form-input
                        id="input-country"
                        class="w-input"
                        v-model="entry.country"
                        v-bind:class="{'form-control':true, 'is-invalid' : !this.countryValid}"
                        aria-describedby="input-live-help input-live-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{countryFeedback}}
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <div style="position:absolute;top:32px;right:16px">
                      <b-button 
                        class="inside-button"
                        v-on:click="noFreeFormat()"
                      >
                        back
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group style="text-align:left">
                      <label class="w-label" for="input-region" style="font-weight:bold; color:rgb(109,122,82) !important">{{ translate("region - free format") }}</label>
                      <b-form-input
                        id="input-region"
                        class="w-input"
                        v-model="entry.region"
                        aria-describedby="input-live-help input-live-feedback"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group style="text-align:left">
                      <label class="w-label" for="input-appellation" style="font-weight:bold; color:rgb(109,122,82) !important">{{ translate("appellation - free format") }}</label>
                      <b-form-input
                        id="input-appellation"
                        class="w-input"
                        v-model="entry.appellation"
                        aria-describedby="input-live-help input-live-feedback"
                      ></b-form-input>
                    </b-form-group>       
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>                
                    <b-form-group style="text-align:left">
                      <label class="w-label" for="input-classification" style="font-weight:bold; color:rgb(109,122,82) !important">{{ translate("classification - free format") }}</label>
                      <b-form-input
                        id="input-classification"
                        class="w-input"
                        v-model="entry.classification"
                        aria-describedby="input-live-help input-live-feedback"
                      ></b-form-input>
                    </b-form-group>     
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col cols="8">
                  <b-form-group style="text-align:left">
                    <b-row>
                      <b-col cols="4" style="padding-right:0">  
                        <label class="w-label w-required" for="colorList">{{ translate("color") }}</label>
                      </b-col>
                      <b-col cols="8" class="text-right" style="padding-left:0">
                        <label class="w-error" v-if="!this.colorValid">{{colorFeedback}}</label>
                      </b-col>
                    </b-row>  
                    <model-select
                      class="w-select"
                      :options="colors"
                      v-model="color_id"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.colorValid}"
                      @input="inputColor"
                    >
                    </model-select>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group style="text-align:left;display: flex;position:relative;top:15px">   
                    <b-form-checkbox 
                      id="sparklingToggle"
                      v-model="entry.sparkling"
                      style="flex: 1;top:10px"
                    >
                    <label class="w-label" for="sparklingToggle">{{ translate("sparkling") }}</label>
                    </b-form-checkbox>
                    <b-form-checkbox 
                      id="sweetToggle"
                      v-model="entry.sweet"
                      style="flex: 2"
                    >
                    <label class="w-label" for="sweetToggle">{{ translate("sweet") }}</label>
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-if="pageCount == 1" class="page">
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <label class="w-label" for="input-occasion">{{ translate("occasion") }}</label>
                    <b-form-input
                      id="input-occasion"
                      class="w-input"
                      v-model="transaction.description"
                      ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <b-row>
                      <b-col>  
                        <label class="w-label w-required" for="input-number">{{ translate("number") }}</label>
                      </b-col>
                      <b-col class="text-right">
                        <label class="w-error" v-if="!this.numberValid">{{numberFeedback}}</label>
                      </b-col>
                    </b-row>
                    <b-form-spinbutton v-if="this.entry_id==0" 
                      class="w-spinbutton" 
                      id="input-number" 
                      v-model="transaction.number"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.numberValid}"
                      aria-describedby="input-live-help input-live-feedback" 
                      min="1" max="1000"
                    >
                    </b-form-spinbutton>
                    <b-form-spinbutton v-else 
                      class="w-spinbutton" 
                      id="input-number" 
                      v-model="transaction.number"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.numberValid}"
                      aria-describedby="input-live-help input-live-feedback" 
                      min="1" max="1000"
                      readonly
                    >
                    </b-form-spinbutton>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <b-row>
                      <b-col>  
                        <label class="w-label w-required" for="input-date">{{ translate("date") }}</label>
                      </b-col>
                      <b-col class="text-right">
                        <label class="w-error" v-if="!this.dateValid">{{dateFeedback}}</label>
                      </b-col>
                    </b-row>
                    <b-form-datepicker 
                      class="w-datepicker mb-2" 
                      id="input-date"
                      :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }" 
                      v-model="transaction.date"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.dateValid}"
                      aria-describedby="input-live-help input-live-feedback"
                    >
                    </b-form-datepicker>
                  </b-form-group>
                </b-col>                     
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <label class="w-label" for="input-price">{{ translate("price") }}</label>
                    <b-form-input
                      id="input-price"
                      class="w-input"
                      v-model="transaction.price"
                      ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>                            
            </div>
            <div v-if="pageCount == 2" class="page">
              <b-form-group style="text-align:left">
                <label class="w-label" for="input-grapes">{{ translate("grapes") }}</label>
                <b-form-input
                  id="input-grapes"
                  class="w-input"
                  v-model="entry.grapes"
                  aria-describedby="input-live-help input-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                {{grapesFeedback}}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group style="text-align:left">
                <label class="w-label" for="input-longevity">{{ translate("longevity") }}</label>
                <b-form-input
                  id="input-longevity"
                  class="w-input"
                  v-model="entry.longevity"
                ></b-form-input>
              </b-form-group>

              <b-form-group style="text-align:left">
                <label class="w-label" for="input-vines">{{ translate("vines") }}</label>
                <b-form-input
                  id="input-vines"
                  class="w-input"
                  v-model="entry.vines"
                ></b-form-input>
              </b-form-group>

              <b-form-group style="text-align:left">
                <label class="w-label" for="input-yields">{{ translate("yields") }}</label>
                <b-form-input
                  id="input-yields"
                  class="w-input"
                  v-model="entry.yields"
                ></b-form-input>
              </b-form-group>

              <b-form-group style="text-align:left">
                <label class="w-label" for="input-vinification">{{ translate("vinification") }}</label>
                <b-form-input
                  id="input-vinification"
                  class="w-input"
                  v-model="entry.vinification"
                ></b-form-input>
              </b-form-group>

              <b-form-group style="text-align:left">
                <label class="w-label" for="input-aging">{{ translate("aging") }}</label>
                <b-form-input
                  id="input-aging"
                  class="w-input"
                  v-model="entry.aging"
                ></b-form-input>
              </b-form-group>

              <b-form-group style="text-align:left">
                <label class="w-label" for="input-alcohol">{{ translate("alcohol") }}</label>
                <b-form-input
                  id="input-alcohol"
                  class="w-input"
                  v-model="entry.alcohol"
                ></b-form-input>
              </b-form-group>

            </div>
            <div v-if="pageCount == 3" class="page">
              <div>
                <br></br>
                <div class="dropzone-container" style="height:275px;width:100%">
                  <b-row class="justify-content-center">
                    <b-col cols="4" style="height:275px;width:16vw">                
                      <div v-if="entry.image_files[0]" class="bottle-box"> 
                        <b-img  
                          v-bind:src="entry.image_files[0].dataURL"
                        >
                        </b-img>
                        <div v-on:click="onDeletePicture(0)" class="delete-picture">
                          <b-img
                            :src="require('@/assets/img/delete-picture.png')"
                            style="width:100%;height:100%;border-radius:50%;border-style:none"
                          ></b-img>
                        </div>
                      </div>
                      <div v-else style="height:275px" class="bottle-box">
                        <p style="margin-top: 15px;font-size: calc(3vw + 7vh);font-family: ui-monospace; color:grey">+</p>
                      </div>
                    </b-col>
                    <b-col cols="4" style="height:275px;width:16vw">               
                      <div v-if="entry.image_files[1]" class="bottle-box"> 
                        <b-img  
                          v-bind:src="entry.image_files[1].dataURL"
                        >
                        </b-img>
                        <div v-on:click="onDeletePicture(1)" class="delete-picture">
                          <img
                            :src="require('@/assets/img/delete-picture.png')"
                            style="height:100%;border-radius:50%;border-style:none"
                          />
                        </div>
                      </div>
                      <div v-else style="height:275px" class="bottle-box">
                        <p style="margin-top: 15px;font-size: calc(3vw + 7vh);font-family: ui-monospace; color:grey">+</p>
                      </div>
                    </b-col>
                    <b-col cols="4" style="height:275px;width:16vw">             
                      <div v-if="entry.image_files[2]" class="bottle-box"> 
                        <b-img  
                          v-bind:src="entry.image_files[2].dataURL"
                        >
                        </b-img>
                        <div v-on:click="onDeletePicture(2)" class="delete-picture">
                          <img
                            :src="require('@/assets/img/delete-picture.png')"
                            style="width:100%;height:100%;border-radius:50%;border-style:none"
                          />
                        </div>
                      </div>
                      <div v-else style="height:275px" class="bottle-box">
                        <p style="margin-top: 15px;font-size: calc(3vw + 7vh);font-family: ui-monospace; color:grey">+</p>
                      </div>
                    </b-col>  
                  </b-row>
                
                  <vue-dropzone 
                    id="imgDropzone" ref="imgDropzone" class="winedropzone" 
                    :options="dropzoneOptions"
                    @vdropzone-thumbnail="vfileAdded" 
                  >
                  </vue-dropzone>
                </div>
                </br></br>
              </div>
            </div>
          </b-form>
          <b-row v-if="ready4Save"> 
            <b-col class="text-right" style="position:relative ;bottom: -10px">
              <b-button v-on:click="onSave()" class="w-button-green-full">{{ translate("save") }}</b-button>
            </b-col>
          </b-row>
          <b-row v-else> 
            <b-col class="text-right" style="position:relative ;bottom: -10px">
              <b-button class="w-button-green-full">
                saving 
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </b-button>
            </b-col>
          </b-row>              
        </div>  
      </b-container>
    </div>
  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';
  import cc64 from '../assets/js/cc64.js';

  import { ModelSelect } from 'vue-search-select';
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';

  import Geographies from '../Geographies.js';
  import Classifications from '../Classifications.js'

  import Cellars from '../Cellars.js'
  import Niches from '../Niches.js'
  import Entries from '../Entries.js'
  import Transactions from '../Transactions.js'

  export default {
    name: "FullDefine",
    components: {
      ModelSelect,
      vueDropzone: vue2Dropzone
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentCellarID() {
        return this.$store.state.cellar_id
      },
      currentCellar() {
        return this.$store.state.cellar
      },
      currentCellarLoaded() {
        return this.$store.state.cellar_loaded
      },

      searchState() {
        return this.$store.state.search_state
      }
    },
    data() {
      return {
        debug: false,
        
        isLoading: true,

        countries: [],
        regions: [],
        appellations:[],
        classifications:[],
        vintages: [],
        colors:[{text:'Red',value:0},{text:'White',value:1},{text:'Rosé',value:2}],
        color_id:'',
        
        // Validation Logic
        nameValid : true,
        nameFeedback : '',
        typeValid : true,
        typeFeedback : '',
        vintageValid : true,
        vintageFeedback : '',
        vinesValid : true,
        vinesFeedback : '',
        grapesValid : true,
        grapesFeedback : '',
        numberValid : true,
        numberFeedback : '',
        dateValid : true,
        dateFeedback : '',
        countryValid : true,
        countryFeedback : '',
        colorValid : true,
        colorFeedback : '',

        isValid: true,

        geographies:[],
        current_geography:{

        },

        entry: {
            name:'',
            type:'',
            country_id:0,
            country:'',
            region_id:0,
            region:'',
            appellation_id:0,
            appellation:'',
            classification_id:0,
            classification:'',
            sparkling:false,
            color:'',
            grapes:'',
            longevity:'',
            vines:'',
            yields:'',
            vinification:'',
            aging:'',
            alcohol:'',
            image_files:[],
            wine_id:0,
            winery_id:0,
            
            number:0,
            vintage:0,

            cellar_id:0,
            niche_id:0,

            transaction_ids:[],
            tasting_note_ids:[],
        },
        entry_id:0,

        region_isActive: false,
        appellation_isActive: true,
        classification_isActive: false,

        freeFormat:false,

        transaction:{
          date:'',
          type:'',
          number:0,
          description:'',
          price:'',
          entry_id:0
        },
        transaction_id:0,

        cellar_id:0,
        cellar: {},

        niche_id:0,
        niche:{},

        // dropzone
        dropzoneOptions: {
          url: 'https://httpbin.org/post',
          previewTemplate: this.template(),
          acceptedFiles:'.jpg,.jpeg,.png',
          dictDefaultMessage : '',
          maxFilesize: 20,
        },

        // paging
        pageCount:0,
        maxPage:3,
        leftVisible:false,
        rightVisible:true,

        // saving
        ready4Save : true,
      }
    }, 

    async mounted() {
      if (this.debug) console.log("")
      if (this.debug) console.log("FullDefine.mounted: START")

      // Fill the vintage list
      var today = new Date();
      var this_year = today.getFullYear();
      for (let i = this_year; i > this_year-100; i--) {
        this.vintages.push({value:i,text:i.toString()});
      }
      this.vintages.push({value:"-",text:"no vintage"});
      
      this.transaction.date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

      // Read the URL
      // this.cellar_id = this.$route.query.cellar_id;
      // await Cellars.getone(this.cellar_id)
      // .then(response=> {
      //   this.cellar = response;
      //   delete this.cellar._id
      //   if (this.debug) console.log( "FullDefine.mounted: Cellar ", this.cellar , " succesfully fetched from DB");
      // })
      // .catch(error=> {
      //   if (this.debug) console.log("FullDefine.mounted: await Cellars.getone ", error);
      // })

      if (this.currentCellarLoaded) {
        this.cellar = this.currentCellar
        this.cellar_id = this.currentCellarID
        if (this.debug) console.log("FullDefine.mounted: Cellar ", this.cellar, " with id ", this.cellar_id, " succesfully retrieved from store.")
      } else {
        console.log("FullDefine.mounted: FATAL ERROR cellar NOT loaded.")
      }

      this.niche_id = this.$route.query.niche_id;
      await Niches.getone(this.niche_id)
      .then(response=> {
        this.niche = response;
        delete this.niche._id
        if (this.debug) console.log( "FullDefine.mounted: Niche ", this.niche , " succesfully fetched from DB");
      })
      .catch(error=> {
        if (this.debug) console.log("FullDefine.mounted: await Niches.getone ", error);
      })
    
      await Geographies.get()
      .then(response=>{
        for (let i = 0 ; i < response.length ; i++) {
          this.geographies.push(response[i])
        }
        if (this.debug) console.log("FullDefine.mounted: Geographies ", response, " succesfully fetched from DB");
      })
      .catch(error=>{
        if (this.debug) console.log("FullDefine.mounted: catch await Geographies.get() - error : ", error);
      })
      
      this.region_isActive = false;
      this.appellation_isActive = false;
      this.classification_isActive = false;      
            
      if (this.debug) console.log('FullDefine.mounted: Checking Entry');
      if (typeof this.$route.query.entry_id !== 'undefined') {
        //ENTRY EXISTS
        this.entry_id = this.$route.query.entry_id;
        this.entry = await Entries.getone(this.$route.query.entry_id);
        delete this.entry._id
        if (typeof this.entry.sweet == "undefined") {
          this.entry.sweet = false
        }
        
        if (this.debug) console.log('FullDefine.mounted: entry_id ' + this.$route.query.entry_id + ' found in URL');
        
        // Fill the color list
        for (let i = 0 ; i < this.colors.length ; i ++) {
          if ( this.colors[i].text == this.entry.color) {
            this.color_id = this.colors[i].value
            if (this.debug) console.log("=====> FullDefine.mounted: this.color_id = ",this.color_id)
          }
        }
        
        // Fill the transaction list
        if (this.entry.transaction_ids.length > 0) {
          await Transactions.getone(this.entry.transaction_ids[0])
          .then(response => {
            this.transaction = response
            this.transaction_id = response._id
            delete this.transaction._id
            if (this.debug) console.log('FullDefine.mounted: Transaction ', this.transaction, ' found in DB');
          })
          .catch(error => {
            if (this.debug) console.log("FullDefine.mounted: await Transaction.getone ", error);
          })
        }
        
        if ( this.entry.country_id !=0) {
          if (this.debug) console.log("FullDefine.mounted: entry has a documented geography.")
        
          if (this.entry.appellation_id !=0) {
            await Geographies.getone(this.entry.appellation_id)
            .then(response => {
              this.current_geography = response
              if (this.debug) console.log("FullDefine.mounted: appellation current_geography is ", response)
            })
            .catch(error =>{
              if (this.debug) console.log("FullDefine.mounted: Geography.get failed with ERROR ", error)
            })
          } else  if (this.entry.region_id !=0) {
             await Geographies.getone(this.entry.region_id)
            .then(response => {
              this.current_geography = response
              if (this.debug) console.log("FullDefine.mounted: region current_geography is ", response)
            })
            .catch(error =>{
              if (this.debug) console.log("FullDefine.mounted: Geography.get failed with ERROR ", error)
            })
          } else  if (this.entry.country_id !=0) {
             await Geographies.getone(this.entry.country_id)
            .then(response => {
              this.current_geography = response
              if (this.debug) console.log("FullDefine.mounted: country  current_geography is ", response)
            })
            .catch(error =>{
              if (this.debug) console.log("FullDefine.mounted: Geography.get failed with ERROR ", error)
            })
          } else {
            if (this.debug) console.log('FullDefine.mounted: Freeformat is on!');
            this.freeFormat = true;
          }

          // Country of existing entry
          for (let i = 0 ; i < this.geographies.length ; i++) {
            if (this.geographies[i].level == 1) {
              this.countries.push({value:this.geographies[i]._id,text:this.geographies[i].name})
            }
          }
          if (this.countries.length > 0) {
            this.countries.sort((a,b)=>(a.text>b.text)?1:-1);
          }

          this.countries.push({value:"Another Country",text:"Another Country"})
     
          // Region of existing entry
          this.regions = [];
          for ( let i = 0 ; i < this.geographies.length ; i++ ) {
            if (this.geographies[i].level == 2) {
              if ( this.geographies[i].country_id == this.entry.country_id ) {
                if (this.debug) console.log("FullDefine.mounted: regions of current country - ", this.geographies[i].name)
                this.regions.push({value:this.geographies[i]._id,text:this.geographies[i].name})
              }
            }
          }
          if (this.regions.length > 0) {
            this.region_isActive = true;
            this.regions.sort((a,b)=>(a.text>b.text)?1:-1);
          } 

          // Appellation of existing entry
          this.appellations = [];
          for ( let i = 0 ; i < this.geographies.length ; i++ ) {
            if (this.geographies[i].level == 3) {
              if ( this.geographies[i].region_id == this.entry.region_id ) {
                this.appellations.push({value:this.geographies[i]._id,text:this.geographies[i].name})
              }
            }
          }     
          if (this.appellations.length > 0) {
            this.appellation_isActive = true;
            this.appellations.sort((a,b)=>(a.text>b.text)?1:-1);
          }  

          // Classification of existing entry
          this.classifications = [];
          if ((typeof this.current_geography.classification_ids != "undefined") && (this.current_geography.classification_ids.length > 0)) {
            for ( let i = 0 ; i < this.current_geography.classification_ids.length ; i++ ) {
              await Classifications.getone(this.current_geography.classification_ids[i])
              .then(response => {
                if (typeof response != "undefined") {
                  if (this.debug) console.log("FullDefine.mounted: classification exists with response ", response)
                  this.classifications.push({value:response._id,text:response.name})
                } else {
                  if (this.debug) console.log("FullDefine.inputCountry: classification ",this.current_geography.classification_ids[i],"DOES NOT exists with response ", response)
                }
              })
              .catch(error => {
                if (this.debug) console.log("FullDefine.inputCountry: classification ",this.current_geography.classification_ids[i],"DOES NOT exists with error ", error)
              })
            }
          }
          this.classifications.sort((a,b)=>(a.order>b.order)?1:-1);
              
          if (this.classifications.length > 0) {
            this.classification_isActive = true
            if ( this.classifications.length == 1) {
              this.entry.classification_id = this.classifications[0].value
            }
          } else {
            this.classification_isActive = false
          }  
        } else {
          this.freeFormat = true
          if (this.debug) console.log("FullDefine.mounted: entry has a free format geography.")
        }

      } else {
        if (this.debug) console.log('FullDefine.mounted: entry_id NOT found in URL - MUST BE NEW');
        this.initCountries();
      }

      this.isLoading = false;

      if (this.debug) console.log("=====> FullDefine.mounted: STOP this.entry = ", this.entry)
      if (this.debug) console.log("=====> FullDefine.mounted: STOP")
    },

    methods:{
      initCountries() {
        this.countries=[]
        this.regions=[]
        this.appellations=[]
        this.classifications=[]
        for (let i = 0 ; i < this.geographies.length ; i++) {
          if (this.geographies[i].level == 1) {
            this.countries.push({value:this.geographies[i]._id,text:this.geographies[i].name})
          }
        }
        this.region_isActive = false;
        this.appellation_isActive = false;
        this.classification_isActive = false;  
        
        this.countries.push({value:"Another Country",text:"Another Country"})
        this.country_id = 0         
      },

      async inputVintage(value) {
        this.entry.vintage = value;
        if (this.debug) console.log("FullDefine.inputVintage - vintage = ",this.entry.vintage)
      },

      async inputCountry(value) {
        if (this.debug) console.log("");        
        if (this.debug) console.log("FullDefine.inputCountry: START");

        this.entry.country_id = value;
        if (this.entry.country_id == "Another Country") {
          this.freeFormat = true;
          this.entry.country_id = 0
          this.entry.country = ""
          this.entry.region_id = 0
          this.entry.region = ""
          this.entry.appellation_id = 0
          this.entry.appellation = ""
          this.entry.classification_id = 0
          this.entry.classification = ""
          return
        }

        this.entry.country = ""
        for (let i=0; i< this.countries.length; i++) {
          if (this.countries[i].value === value) {
            this.entry.country = this.countries[i].text
          }
        }

        if (this.debug) console.log("FullDefine.inputCountry: country_id = ",this.entry.country_id);
        if (this.debug) console.log("FullDefine.inputCountry: country = ",this.entry.country);

        this.regions =[];
        this.entry.region_id = 0 ;
        this.entry.region = '';

        this.appellations = [];
        this.entry.appellation_id = 0;
        this.entry.appellation = '';

        // Adapt regions
        this.regions = [];
        this.appellations =[];
        for(let i = 0; i < this.geographies.length ; i++ ) {
          if (this.geographies[i]._id == value) {
            this.current_geography = this.geographies[i];
          }
          if (this.geographies[i].level == 2 && this.geographies[i].country_id == value)  {
            this.regions.push({value:this.geographies[i]._id,text:this.geographies[i].name})
          }
          if (this.geographies[i].level == 3 && this.geographies[i].country_id == value)  {
            this.appellations.push({value:this.geographies[i]._id,text:this.geographies[i].name})
          }
        }

        if (this.debug) console.log( "FullDefine.inputCountry: Regions from Country ", this.entry.country," ", this.regions, " succesfully found");
        if (this.debug) console.log( "FullDefine.inputCountry: Appellations from Country ", this.entry.country," ", this.appellations, " succesfully found");
      
        if (this.regions.length > 0 ) {
          this.regions.sort((a,b)=>(a.text>b.text)?1:-1);
          this.region_isActive = true
        } else {
          this.region_isActive = false
        }

        if (this.appellations.length > 0) {
          this.appellations.sort((a,b)=>(a.text>b.text)?1:-1);
          this.appellation_isActive = true;
        } else {
          this.appellation_isActive = false;
        }

        this.classifications =[];
        this.entry.classification_id = 0;
        this.entry.classification = '';

        // Adapt classifications
        this.classifications = []
        for ( let i = 0 ; i < this.current_geography.classification_ids.length ; i ++) {
          await Classifications.getone(this.current_geography.classification_ids[i])
          .then(response => {
            if (typeof response != "undefined") {
              if (this.debug) console.log("FullDefine.inputCountry: classification exists with response ", response)
              this.classifications.push({value:response._id,text:response.name})
            } else {
              if (this.debug) console.log("FullDefine.inputCountry: classification ",this.current_geography.classification_ids[i],"DOES NOT exists with response ", response)
            }

          })
          .catch(error => {
            if (this.debug) console.log("FullDefine.inputCountry: classification ",this.current_geography.classification_ids[i],"DOES NOT exists with error ", error)
          })
        }
        this.classifications.sort((a,b)=>(a.order>b.order)?1:-1);
            
        if (this.classifications.length > 0) {
          this.classification_isActive = true
        } else {
          this.classification_isActive = false
        }        
        
        if (this.debug) console.log("FullDefine.inputCountry: STOP");
      },

      async inputRegion(value) {
        if (this.debug) console.log("")
        if (this.debug) console.log("FullDefine.inputRegion: START")

        this.entry.region_id = value;
        this.entry.region = '';
        for (let i=0; i< this.regions.length; i++) {
          if (this.regions[i].value === value) {
            this.entry.region = this.regions[i].text;
          }
        }

        if (this.debug) console.log("FullDefine.inputRegion: region_id = ",this.entry.region_id)
        if (this.debug) console.log("FullDefine.inputRegion: region = ",this.entry.region)

        this.appellations = [];
        this.entry.appellation_id = 0;
        this.entry.appellation = '';

        if(typeof this.entry.region_id !== 'undefined') {  
          // Adapt regions
          for(let i = 0; i < this.geographies.length ; i++ ) {
            if (this.geographies[i]._id == value) {
              this.current_geography = this.geographies[i];
            }
            if (this.geographies[i].level == 3 && this.geographies[i].region_id == value)  {
              this.appellations.push({value:this.geographies[i]._id,text:this.geographies[i].name})
            }
          }

          if (this.debug) console.log( "FullDefine.inputRegion: Appellations from Region ", this.entry.region," ", this.appellations, " succesfully found");
      
          if (this.appellations.length > 0 ) {
            this.appellations.sort((a,b)=>(a.text>b.text)?1:-1);
            this.appellation_isActive = true
          } else {
            this.appellation_isActive = false
          }

          this.classifications = [];
          this.entry.classification_id = 0;
          this.entry.classification = '';

          // Add classifications
          this.classifications = []
          if ((typeof this.current_geography.classification_ids != "undefined") && (this.current_geography.classification_ids.length > 0)) {
            for ( let i = 0 ; i < this.current_geography.classification_ids.length ; i ++) {
              await Classifications.getone(this.current_geography.classification_ids[i])
              .then(response => {
                if (typeof response != "undefined") {
                  if (this.debug) console.log("FullDefine.inputCountry: classification exists with response ", response)
                  this.classifications.push({value:response._id,text:response.name})
                } else {
                  if (this.debug) console.log("FullDefine.inputCountry: classification ",this.current_geography.classification_ids[i],"DOES NOT exists with response ", response)
                }

              })
              .catch(error => {
                if (this.debug) console.log("FullDefine.inputCountry: classification ",this.current_geography.classification_ids[i],"DOES NOT exists with error ", error)
              })
            }
          }
          this.classifications.sort((a,b)=>(a.order>b.order)?1:-1);
              
          if (this.classifications.length > 0) {
            this.classification_isActive = true
          } else {
            this.classification_isActive = false
          }          

          if (this.debug) console.log("FullDefine.inputRegion: STOP")
        }  
      },

      async inputAppellation(value) {
        if (this.debug) console.log("")
        if (this.debug) console.log("FullDefine.inputAppellation: START")

        this.entry.appellation_id = value;
        // for (let i = 0; i < this.appellations.length; i++) {
        //   if (this.appellations[i].value == value ) {
        //     this.entry.appellation = this.appellations[i].text
        //   }
        // }

        for(let i = 0; i < this.geographies.length ; i++ ) {
          if (this.geographies[i]._id == value) {
            this.current_geography = this.geographies[i];
          }
        }

        if (this.debug) console.log("FullDefine.inputAppellation: current_geography = ",this.current_geography)
        if (this.debug) console.log("FullDefine.inputAppellation: appellation_id = ",this.entry.appellation_id)
        if (this.debug) console.log("FullDefine.inputAppellation: appellation = ",this.entry.appellation)
        
        if (this.entry.country_id == 0 || this.entry.country_id == "") {
          this.entry.country_id = this.current_geography.country_id
          this.region_isActive = true;
          for(let i = 0; i < this.geographies.length ; i++ ) {
            if (this.geographies[i].level == 2 && this.geographies[i].country_id == this.entry.country_id)  {
              this.regions.push({value:this.geographies[i]._id,text:this.geographies[i].name})
            }
          }
        }
        for (let i=0; i< this.countries.length; i++) {
          if (this.countries[i].value === this.entry.country_id) {
            this.entry.country = this.countries[i].text;
          }
        }
        if (this.debug) console.log("FullDefine.inputAppellation: country_id = ",this.entry.country_id)
        if (this.debug) console.log("FullDefine.inputAppellation: country = ",this.entry.country)

        if (this.entry.region_id == 0 || this.entry.region_id == "") {
          this.entry.region_id = this.current_geography.region_id
        }
        for (let i=0; i< this.regions.length; i++) {
          if (this.regions[i].value === this.entry.region_id) {
            this.entry.region = this.regions[i].text;
          }
        }
        if (this.debug) console.log("FullDefine.inputAppellation: region_id = ",this.entry.region_id)
        if (this.debug) console.log("FullDefine.inputAppellation: region = ",this.entry.region)

        // Add classificationss
        this.classifications = []
        this.classification_id = '';
        if ((typeof this.current_geography.classification_ids != "undefined") && (this.current_geography.classification_ids.length > 0)) {
          for ( let i = 0 ; i < this.current_geography.classification_ids.length ; i ++) {
            await Classifications.getone(this.current_geography.classification_ids[i])
            .then(response => {
              if (typeof response != "undefined") {
                if (this.debug) console.log("FullDefine.inputCountry: classification exists with response ", response)
                this.classifications.push({value:response._id,text:response.name})
              } else {
                if (this.debug) console.log("FullDefine.inputCountry: classification ",this.current_geography.classification_ids[i],"DOES NOT exists with response ", response)
              }

            })
            .catch(error => {
              if (this.debug) console.log("FullDefine.inputCountry: classification ",this.current_geography.classification_ids[i],"DOES NOT exists with error ", error)
            })
          }
        }
        this.classifications.sort((a,b)=>(a.order>b.order)?1:-1);
            
        if (this.classifications.length > 0) {
          this.classification_isActive = true
          if ( this.classifications.length == 1) {
            this.entry.classification_id = this.classifications[0].value
          }
        } else {
          this.classification_isActive = false
        }
        for (let i=0; i< this.classifications.length; i++) {
          if (this.classifications[i].value === this.entry.classification_id) {
            this.entry.classification = this.classifications[i].text;
          }
        }

        // New 2022-08-03 Adapt Appellationlist accourding to selected region
        this.appellations = []
        for(let i = 0; i < this.geographies.length ; i++ ) {
          if (this.geographies[i]._id == value) {
            this.current_geography = this.geographies[i];
          }
          if (this.geographies[i].level == 3 && this.geographies[i].region_id == this.entry.region_id)  {
            this.appellations.push({value:this.geographies[i]._id,text:this.geographies[i].name})
          }
        }
        if (this.appellations.length > 0 ) {
          this.appellations.sort((a,b)=>(a.text>b.text)?1:-1);
          this.appellation_isActive = true
        } else {
          this.appellation_isActive = false
        }
        for (let i = 0; i < this.appellations.length; i++) {
          if (this.appellations[i].value == value ) {
            this.entry.appellation = this.appellations[i].text
          }
        } 
        
        if (this.debug) console.log("FullDefine.inputAppellation: classification_id = ",this.entry.classification_id)
        if (this.debug) console.log("FullDefine.inputAppellation: classification = ",this.entry.classification)

        if (this.debug) console.log("FullDefine.inputAppellation: STOP")
      },

      inputClassification(value) {
        this.entry.classification_id = value;
        if (this.debug) console.log("FullDefine.inputClassification - classification_id = ",this.entry.classification_id)
        for (let i = 0; i < this.classifications.length; i++) {
          if (this.classifications[i].value == value ) {
            this.entry.classification = this.classifications[i].text
          }
        }
        if (this.debug) console.log("FullDefine.inputClassification - classification = ",this.entry.classification)
      },

      inputColor(value) {
        if (this.debug) if (this.debug) console.log("FullDefine.inputColor - value = ",value) 
        for (let i = 0; i < this.colors.length; i++) {
          if (this.colors[i].value == value ) {
            this.entry.color = this.colors[i].text;
            this.color_id = i;
          }
        }
        if (this.debug) if (this.debug) console.log("FullDefine.inputColor - color = ",this.entry.color)
      },

      onDeletePicture(i){
        this.entry.image_files.splice(i, 1);
        this.hasChanged = true;
      },

      validate_form(){
        if(this.entry.name.length < 3) {
          this.nameValid = false;
          this.nameFeedback = "minimum 3 characters"
        }  
        else {
          this.nameValid = true;
          this.nameFeedback = ""
        }

        if(this.entry.vintage == 0) {
          this.vintageValid = false;
          this.vintageFeedback = "select valid vintage"
        } 
        else {
          this.vintageValid = true;
          this.vintageFeedback = ""
        }

        if (!this.freeFormat) {
          if(this.entry.country_id == 0) {
            this.countryValid = false;
            this.countryFeedback = "select valid country"
          } 
          else {
            this.countryValid = true;
            this.countryFeedback = ""
          }
        } else {
          if(this.entry.country.length < 3) {
            this.countryValid = false;
            this.countryFeedback = "minimum 3 characters"
          } 
          else {
            this.countryValid = true;
            this.countryFeedback = ""
          }
        }  

        if(this.entry.color == "") {
          this.colorValid = false;
          this.colorFeedback = "select valid color"
        } 
        else {
          this.colorValid = true;
          this.colorFeedback = ""
        } 

        if( this.transaction.number <= 0) {
            this.numberValid = false;
            this.numberFeedback = "select valid number"
        } else {
            this.numberValid = true
            this.numberFeedback = ""
        }

        if ( this.transaction.date == '') {
          this.dateValid=false;
          this.dateFeedback='Choose a valid date';
        } else {
          this.dateValid=true;
          this.dateFeedback='';
          // format date yyyy-mm-dd
          let dateArray = this.transaction.date.split("-");
          if (dateArray[1].length == 1) {
            dateArray[1] = "0" + dateArray[1]
          }
          if (dateArray[2].length == 1) {
            dateArray[2] = "0" + dateArray[2]
          }
          this.transaction.date = dateArray[0] + "-" + dateArray[1] + "-" + dateArray[2]
        }
        
        this.isValid = this.nameValid && this.vintageValid && this.numberValid && this.dateValid && this.countryValid && this.colorValid;
      },

      async onSave() {
        if (this.debug) console.log("");
        if (this.debug) console.log("FullDefine.onSave: START");
        this.ready4Save = false;
        
        this.entry.cellar_id = this.cellar_id;
        this.entry.niche_id = this.niche_id;

        if (this.debug) console.log("FullDefine.onSave: BEFORE READING THE FORMS this.entry = ", this.entry);

        //READING THE FORMS
        this.validate_form();
        if (!this.isValid) {
          if (this.nameValid && this.vintageValid && this.countryValid && this.colorValid) {
            this.pageCount = 1
            this.leftVisible = true;
            this.rightVisible = true;
          } else {
            this.pageCount = 0;
            this.leftVisible = false;
            this.rightVisible = true;
          }
          if (this.debug) console.log("FullDefine.onSave: Returning without Save because validation form failed.")
          this.ready4Save = true;
          return;
        }

        if (this.debug) console.log("FullDefine.onSave: AFTER READING THE FORMS this.entry = ", this.entry)
        if (this.debug) console.log("FullDefine.onSave: AFTER READING THE FORMS this.transaction = ", this.transaction)

        if ( this.entry_id == 0 ) {
          if (this.debug) console.log("FullDefine.onSave: Entry does NOT exist - we create it");
          
          // Updating a transaction from form data
          this.entry.number = this.transaction.number;

          // Creating Entry
          await Entries.create(this.entry)
          .then(response=>{
            this.entry_id = response;
            if (this.debug) console.log("FullDefine.onSave: Entry succesfully created : id = ", response);
          })
          .catch(error=>{
            if (this.debug) console.log("FullDefine.onSave: catch await Entries.create ERROR :", error);
          }) 

          // Adding this.entry_id to the list of this.niche
          if (this.debug) console.log("FullDefine.onSave: Adding entry to entry_ids from niche ", this.niche.name)       
          this.niche.entry_ids.push(this.entry_id);
          await Niches.update(this.niche_id,this.niche)
          .then(response=>{
            if (this.debug) console.log("FullDefine.onSave: Niche succesfully added entry : id = ", response);
          })
          .catch(error=>{
            if (this.debug) console.log("FullDefine.onSave: catch await Niche.update ", error);
          })  
          
          // Adding this.entry_id to the list of this.cellar
          if (this.debug) console.log("FullDefine.onSave: Adding entry to entry_ids from cellar ", this.cellar.name)
          this.cellar.entry_ids.push(this.entry_id);
          
          await Cellars.update(this.cellar_id,this.cellar)
          .then(response=>{
            if (this.debug) console.log("FullDefine.onSave: Cellar succesfully added niche : id = ", response);
          })
          .catch(error=>{
            if (this.debug) console.log("FullDefine.onSave: catch await Cellar.update ", error);
          })  

          this.transaction.entry_id = this.entry_id;
          if (this.debug) console.log("FullDefine.onSave: this.transaction = ", this.transaction)
          await Transactions.create(this.transaction)
          .then(response=>{
            this.transaction_id = response;
            if (this.debug) console.log("FullDefine.onSave: Transaction succesfully created : id = ", response);
          })
          .catch(error=>{
            if (this.debug) console.log("FullDefine.onSave: catch await Transaction.create ERROR :", error);
          })
          this.entry.transaction_ids.push(this.transaction_id);

        } else {
          if (this.debug) console.log("FullDefine.onSave: Entry DOES exist - we update it");
          if (this.debug) console.log("FullDefine.onSave: Entry DOES exist: id = ", this.entry_id, " entry = ", this.entry);

          await Transactions.update(this.transaction_id,this.transaction)
            .then(response=>{
              if (this.debug) console.log("FullDefine.onSave: Transaction succesfully updated : id = ", response);
            })
            .catch(error=>{
              if (this.debug) console.log("FullDefine.onSave: catch await Transaction.update ERROR :", error);
            })
        }

        await Entries.update(this.entry_id, this.entry)
        .then(response=>{
          if (this.debug) console.log("FullDefine.onSave: Entry succesfully updated : id = ", response);
        })
        .catch(error=>{
          if (this.debug) console.log("FullDefine.onSave: catch await Entry.update ERROR :", error);
        })
        
        this.ready4Save = true;
        this.$router.push({path:'/NicheShow', query: {cellar_id:this.cellar_id,niche_id:this.niche_id }});
        this.$store.commit('setPage','NicheShow')
        await this.$forceUpdate();
        if (this.debug) console.log("FullDefine.onSave: STOP");
      },

      async vfileAdded(new_image_file) {
        let local_debug = true
        if ( !new_image_file.manuallyAdded ) {
          if (local_debug || this.debug) console.log("wine picture URL: ", new_image_file);
          let org_base64 = new_image_file.dataURL;
          let cc_base64 = await cc64(org_base64,1,3);
          new_image_file.dataURL = cc_base64;
          this.entry.image_files.push(new_image_file);
          if (this.entry.image_files.length > 3) {
            this.entry.image_files.shift();
          }
          this.hasChanged = true;
          this.$refs.imgDropzone.removeFile(new_image_file);
          //this.onSave();
        }
      },

      vfileRemoved(image_file) {
        // this.entry.image_files.pop(image_file);
        for( var i = 0; i < this.entry.image_files.length; i++){
          if ( this.entry.image_files[i].dataURL === image_file.dataURL) { 
            this.entry.image_files.splice(i, 1); 
          }
        }
        this.hasChanged = true
      },
      template: function () {
         return `<div class="dz-preview">
                </div>
        `;
      },

      noFreeFormat() {
        this.initCountries()
        this.freeFormat = false;
      },

     async  onLeft() {
        this.pageCount--;
        if (this.pageCount > 0) {
          this.leftVisible = true;
        } else {
          this.leftVisible = false;
        }
        if (this.pageCount >= this.maxPage) {
          this.rightVisible = false;
        } else {
          this.rightVisible = true;
        }
        // await this.onSave()
      },
      async onRight() {
        this.pageCount++;
        if (this.pageCount > 0) {
          this.leftVisible = true;
        } else {
          this.leftVisible = false;
        }
        if (this.pageCount >= this.maxPage) {
          this.rightVisible = false;
        } else {
          this.rightVisible = true;
        }
        // await this.onSave()
      },
      async onWine() {
        this.pageCount = 0;
        this.leftVisible = false;
        this.rightVisible = true;
        // await this.onSave()
      },
      async onPurchase() {
        this.pageCount = 1;
        this.leftVisible = true;
        this.rightVisible = true;
        // await this.onSave()
      }, 
      async onDetail() {
        this.pageCount = 2;
        this.leftVisible = true;
        this.rightVisible = true;
        // await this.onSave()
      },
      async onPictures() {
        this.pageCount = 3;
        this.leftVisible = true;
        this.rightVisible = false;
        // await this.onSave()
      },

      translate(string) {
        return translate_word(string, this.currentLanguage);
      },
    }
  }    
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
/* Custom Dropzone */
.dropzone-container {
  position: relative;
  width: 100%;
  height: 100%; 
}

.winedropzone {

  position: absolute;
  top:10px; right:0; bottom:0; left:0;
  height: 275px;

  background-color: transparent !important;

  border-style: none;
  border-radius: 5px;

  color:#696969;

  transition: background-color .2s linear;
}
</style>